<template>
  <md-input-item
    v-bind="$attrs"
    :placeholder="$t('inputPhoneNum')"
    class="input-phone-number"
    :maxlength="maxlength"
    v-on="$listeners"
  />
</template>

<script>
import { InputItem } from 'mand-mobile'
import { MOBILE_PHONE_MAX_LENGTH } from '@/constants'

// HACK
InputItem.computed.inputMaxLength = function () {
  return this.maxlength
}

export default {
  name: 'InputPhoneNumber',

  components: {
    [InputItem.name]: InputItem
  },

  props: {
    maxlength: {
      type: Number,
      default: MOBILE_PHONE_MAX_LENGTH
    }
  }
}
</script>

<style scoped lang="scss">
.input-phone-number {
  box-sizing: border-box;
  width: 100%;
  height: 112px;
  line-height: 112px;
  background: #fff;
  border-radius: 32px;
  padding: 0 48px;
  box-shadow: 0 8px 32px 0 rgba(138, 149, 158, 0.2);

  ::v-deep.md-field-item-content {
    height: 100%;

    &::before {
      border-bottom: none;
    }
  }
}
</style>
